import { UserTypeContext } from 'cc-locations'

export const TREASURY_OPERATOR: UserTypeContext = 'TREASURY_OPERATOR'
export const MERCHANT: UserTypeContext = 'MERCHANT'
export const NONE: UserTypeContext = 'NONE'
